import * as Yup from "yup";

export const RDD_INITIAL_VALUES = {
  "Creatinine Mass/volume in Urine collected for unspecified duration": "",
  Age: "",
  "Alkaline phosphatase serum/plasma": "",
  "Lymphocytes volume in Blood": "",
  "Glucose Mass/volume in Serum, Plasma or Blood": "",
  "Urea nitrogen Mass/volume in Blood": "",
  "Monocytes/100 leukocytes in Body fluid": "",
  "Neutrophils volume in Blood": "",
  "Eosinophils volume in Blood": "",
  "Protein Mass/volume in Urine": "",
  "Platelet count": "",
};

export const RDD_INITIAL_VALUES_LOW_RISK = {
  "Creatinine Mass/volume in Urine collected for unspecified duration": 1.02,
  Age: 43,
  "Alkaline phosphatase serum/plasma": 87.43,
  "Lymphocytes volume in Blood": 2.21,
  "Glucose Mass/volume in Serum, Plasma or Blood": 112.95,
  "Urea nitrogen Mass/volume in Blood": 13.82,
  "Monocytes/100 leukocytes in Body fluid": 7.77,
  "Neutrophils volume in Blood": 5.74,
  "Eosinophils volume in Blood": 0.16,
  "Protein Mass/volume in Urine": 8.67,
  "Platelet count": 255.49,
};

export const RDD_INITIAL_VALUES_HIGH_RISK = {
  "Creatinine Mass/volume in Urine collected for unspecified duration": 7,
  Age: 50,
  "Alkaline phosphatase serum/plasma": 95,
  "Lymphocytes volume in Blood": 7,
  "Glucose Mass/volume in Serum, Plasma or Blood": 119.73,
  "Urea nitrogen Mass/volume in Blood": 15.2,
  "Monocytes/100 leukocytes in Body fluid": 9.8,
  "Neutrophils volume in Blood": 8.74,
  "Eosinophils volume in Blood": 2.86,
  "Protein Mass/volume in Urine": 8.67,
  "Platelet count": 220.27,
};

export const RDD_VALIDATION_SCHEMA = Yup.object().shape({
  "Creatinine Mass/volume in Urine collected for unspecified duration":
    Yup.number()
      .min(0, "Must be greater than 0")
      .max(30, "Must be less than 30")
      .required("Required (Mean: 1.02)"),
  Age: Yup.number()
    .min(1, "Must be greater or equal to 1")
    .max(120, "Must be less than 120")
    .required("Required (Mean: 43)"),
  "Alkaline phosphatase serum/plasma": Yup.number()
    .min(46, "Must be greater than 46")
    .max(126, "Must be less than 126")
    .required("Required (Mean: 87.43)"),
  "Lymphocytes volume in Blood": Yup.number()
    .min(0.2, "Must be greater or equal to 0.2")
    .max(16, "Must be less than 16")
    .required("Required (Mean: 2.21)"),
  "Glucose Mass/volume in Serum, Plasma or Blood": Yup.number()
    .min(74, "Must be greater than 74")
    .max(130, "Must be less than 130")
    .required("Required (Mean: 112.95)"),
  "Urea nitrogen Mass/volume in Blood": Yup.number()
    .min(4, "Must be greater than 4")
    .max(20, "Must be less than 20")
    .required("Required (Mean: 13.82)"),
  "Monocytes/100 leukocytes in Body fluid": Yup.number()
    .min(0, "Must be greater or equal to 0")
    .max(16, "Must be less than 16")
    .required("Required (Mean: 7.77)"),
  "Neutrophils volume in Blood": Yup.number()
    .min(0.2, "Must be greater than 0.2")
    .max(16, "Must be less than 16")
    .required("Required (Mean: 5.74)"),
  "Eosinophils volume in Blood": Yup.number()
    .min(0, "Must be greater than 0")
    .max(16, "Must be less than 16")
    .required("Required (Mean: 0.16)"),
  "Protein Mass/volume in Urine": Yup.number()
    .min(6.4, "Must be greater than 6.4")
    .max(30, "Must be less than 30")
    .required("Required (Mean: 8.67)"),
  "Platelet count": Yup.number()
    .min(0.1, "Must be greater than 0.1")
    .max(400, "Must be less than 400")
    .required("Required (Mean: 255.49)"),
});

export const PATIENT_FORM_FIELD_DETAILS = [
  {
    id: 1,
    label: "Creatine Mass/Volume in Urine",
    name: "Creatinine Mass/volume in Urine collected for unspecified duration",
    tooltipContent: "Enter a number between 0 and 30 (Mean: 1.02)",
  },
  {
    id: 2,
    label: "Age of the patient",
    name: "Age",
    tooltipContent: "Enter a number between 1 and 120 (Mean: 43)",
  },
  {
    id: 3,
    label: "Alkaline phosphatase serum/plasma",
    name: "Alkaline phosphatase serum/plasma",
    tooltipContent: "Enter a number between 0 and 126 (Mean: 87.43)",
  },
  {
    id: 4,
    label: "Lymphocytes volume in blood",
    name: "Lymphocytes volume in Blood",
    tooltipContent: "Enter a number between 0.2 and 16 (Mean: 2.21)",
  },
  {
    id: 5,
    label: "Glucose Mass/volume in Serum, Plasma or Blood",
    name: "Glucose Mass/volume in Serum, Plasma or Blood",
    tooltipContent: "Enter a number between 0 and 106 (Mean: 112.95)",
  },
  {
    id: 6,
    label: "Urea nitrogen Mass/volume in Blood",
    name: "Urea nitrogen Mass/volume in Blood",
    tooltipContent: "Enter a number between 0 and 30 (Mean: 13.82)",
  },
  {
    id: 7,
    label: "Monocytes/100 leukocytes in Body fluid",
    name: "Monocytes/100 leukocytes in Body fluid",
    tooltipContent: "Enter a number between 0 and 16 (Mean: 7.77)",
  },
  {
    id: 8,
    label: "Neutrophils /volume in Blood",
    name: "Neutrophils volume in Blood",
    tooltipContent: "Enter a number between 0.2 and 16 (Mean: 5.74)",
  },
  {
    id: 9,
    label: "Eosinophils /volume in Blood",
    name: "Eosinophils volume in Blood",
    tooltipContent: "Enter a number between 0 and 16 (Mean: 0.16)",
  },
  {
    id: 10,
    label: "Protein Mass/volume in Urine",
    name: "Protein Mass/volume in Urine",
    tooltipContent: "Enter a number between 0 and 30 (Mean: 8.67)",
  },
  {
    id: 11,
    label: "Platelet count",
    name: "Platelet count",
    tooltipContent: "Enter a number between 0.1 and 400 (Mean: 255.49)",
  },
];

export const SEARCH_INPUT_FIELDS = [
  {
    title: "Use Patient ID",
    tooltipContent: "Enter a valid patient ID",
  },
  {
    title: "Use Patient Name and Date of Birth",
    tooltipContent:
      "Enter patient name and date of birth in the (YYYY-MM-DD) format",
  },
];

export const PATIENT_NAME_IS_CHECKED = "patientNameIsChecked";
export const PATIENT_ID_IS_CHECKED = "patientIdIsChecked";
